export const environment = {
  appId: 2,
  appName: "adoretheballoon",
  IsProd: true,
  baseUrl: "https://dev-api.adoretheballoon.com/api",
  pwaFrontendBaseUrl: "https://dev-app.adoretheballoon.com",
  insizonBackendBaseUrl: "https://dev-api.insizon.com/api",
  insizonFrontendBaseUrl: "https://dev.insizon.com",
  AdoreTheBalloonDatingAppId: "690fad57f61d5fd8dc487cd2",
};
